import { render, staticRenderFns } from "./PostSection2.vue?vue&type=template&id=5b2ba98c&scoped=true"
import script from "./PostSection2.vue?vue&type=script&lang=js"
export * from "./PostSection2.vue?vue&type=script&lang=js"
import style0 from "./PostSection2.vue?vue&type=style&index=0&id=5b2ba98c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ba98c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2ba98c')) {
      api.createRecord('5b2ba98c', component.options)
    } else {
      api.reload('5b2ba98c', component.options)
    }
    module.hot.accept("./PostSection2.vue?vue&type=template&id=5b2ba98c&scoped=true", function () {
      api.rerender('5b2ba98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blog/PostSection2.vue"
export default component.exports